import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { networkKeys } from "../../samples/queryKeys";
import { UrlReport } from "../@types";
import networkApi from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";
import { removeSurroundingQuotes } from "../util";

const { cloud_enabled: cloudEnabled } = window.tcbase.consts;

export const defaultURLReportQueryOptions = (url: string) => ({
  queryKey: networkKeys.urlReport(url),
  queryFn: () => networkApi.urlReport({ url }),
  select: ({ data }: AxiosResponse<UrlReport>) => data,
  enabled: Boolean(url && cloudEnabled),
  ...USEQUERY_DISABLE_REFETCH_OPTIONS
});

const useNetworkThreatIntelURLReport = (_url: string) => {
  const url = removeSurroundingQuotes(_url);
  const {
    data: networkRepData,
    error,
    isFetching,
    isLoading,
    isSuccess,
    refetch
  } = useQuery<
    AxiosResponse<UrlReport>,
    AxiosResponse<{ message: string; requested_url: string }>,
    UrlReport
  >({
    ...defaultURLReportQueryOptions(url)
  });

  return {
    data: networkRepData,
    isFetching,
    isLoading,
    isSuccess,
    error: error?.data?.message,
    refetch
  };
};
export default useNetworkThreatIntelURLReport;
